import React, { lazy, Suspense } from 'react';

const LazySecurityBox = lazy(() => import('./SecurityBox'));

const SecurityBox = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => (
  <Suspense fallback={null}>
    <LazySecurityBox {...props} />
  </Suspense>
);

export default SecurityBox;
